import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { CleverPushSubscriptionsComponent } from '@zero/alerting/feature-alerting/web';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { IconComponent, SwitchComponent } from '@zero/shared/ui-web-design-system';
import { UserEmailSettings } from '@zero/shared/util-models';
import { HttpResponseHandleHelper } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'self-service-notification-administration',
  templateUrl: './notification-administration.component.html',
  imports: [LoadingIndicatorDirective, FormsModule, CleverPushSubscriptionsComponent, SwitchComponent, IconComponent],
})
export class NotificationAdministrationComponent extends BaseComponent {
  public emailOrdersNotification: boolean | undefined;
  public emailMoneyNotification: boolean | undefined;
  public resultError = false;
  public resultMessage: string | undefined;
  public ongoingRequest = false;

  readonly #settingsUrl = `${environment.apihost + environment.usersettings}/emailnotification`;
  readonly #http = inject(HttpClient);

  #loadEmailNotificationSetting(): void {
    this.ongoingRequest = true;
    this.resultError = false;
    this.resultMessage = '';

    HttpResponseHandleHelper.handleResponse(
      this.#http.get<UserEmailSettings>(this.#settingsUrl, {
        params: HttpResponseHandleHelper.skipGlobalHandler(),
      }),
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result.success) {
          this.emailOrdersNotification = result.data.emailnotification_orders;
          this.emailMoneyNotification = result.data.emailnotification_money;
        } else {
          this.resultMessage = 'Fehler beim Laden Deiner Einstellungen.';
          this.resultError = true;
        }
        this.ongoingRequest = false;
      });
  }

  public changeEmailNotification(key: string, val: boolean): void {
    const beforeRequest = key === 'emailnotification_orders' ? this.emailOrdersNotification : this.emailMoneyNotification;
    this.#resetResult();
    const postBody = {};
    postBody[key] = val;
    this.ongoingRequest = true;
    HttpResponseHandleHelper.handleResponse(
      this.#http.post<boolean>(this.#settingsUrl, postBody, {
        params: HttpResponseHandleHelper.skipGlobalHandler(),
      }),
    ).subscribe((result) => {
      if (result.success) {
        if (key === 'emailnotification_orders') {
          this.emailOrdersNotification = result.data;
        } else if (key === 'emailnotification_money') {
          this.emailMoneyNotification = result.data;
        }
        this.resultMessage = 'Deine Einstellungen wurden gespeichert.';
      } else {
        this.resultMessage = result.message;
        this.resultError = true;

        if (key === 'emailnotification_orders') {
          this.emailOrdersNotification = beforeRequest;
        } else if (key === 'emailnotification_money') {
          this.emailMoneyNotification = beforeRequest;
        }
      }
      this.ongoingRequest = false;
    });
  }

  public toggleShowMe(): void {
    this.showMe = !this.showMe;
    if (this.showMe) {
      this.#loadEmailNotificationSetting();
    } else {
      this.#resetResult();
      this.emailOrdersNotification = undefined;
    }
  }

  #resetResult(): void {
    this.resultError = false;
    this.resultMessage = undefined;
  }
}
